import { useCallback } from 'react';
import api from '../services/api';

export interface InteractionData {
  toolUsed: string;
  query: string;
  response?: string;
  success: boolean;
  feedback?: number;
  metadata?: Record<string, any>;
  sessionId?: string;
}

export const useInteractionLogger = () => {
  const logInteraction = useCallback(async (data: InteractionData) => {
    try {
      // Detect platform
      const platform = detectPlatform();

      await api.post('/api/learning/interactions', {
        ...data,
        platform,
        timestamp: new Date().toISOString()
      });
    } catch (error) {
      // Silently fail - logging shouldn't break the user experience
      console.warn('Failed to log interaction:', error);
    }
  }, []);

  const logFeedback = useCallback(async (
    toolName: string,
    rating: number,
    comments?: string,
    context?: string
  ) => {
    try {
      await api.post('/api/learning/feedback', {
        toolName,
        rating,
        comments,
        context,
        sessionId: getSessionId()
      });
    } catch (error) {
      console.warn('Failed to log feedback:', error);
    }
  }, []);

  return {
    logInteraction,
    logFeedback
  };
};

const detectPlatform = (): string => {
  if (typeof window !== 'undefined' && (window as any).electronAPI) {
    return 'electron';
  }
  if (typeof window !== 'undefined' && (window as any).acquireVsCodeApi) {
    return 'vscode';
  }
  return 'web';
};

const getSessionId = (): string => {
  // Generate or retrieve session ID
  let sessionId = sessionStorage.getItem('mawi-session-id');
  if (!sessionId) {
    sessionId = `session-${Date.now()}-${Math.random().toString(36).substr(2, 9)}`;
    sessionStorage.setItem('mawi-session-id', sessionId);
  }
  return sessionId;
};